import React, {useEffect, useState} from 'react';
import PostSnippet from './PostSnippet';
import _ from 'lodash';
import db from '../firebase'

const AllOrders = (props) => {

    const [posts, setPosts] = useState([])

    useEffect(() => {
        let postsRef = db.collection('servicerequests')

        postsRef
            .get()
            .then(posts => {
                posts.forEach(post => {
                    let data = post.data()
                    let { id } = post

                    let payload = {
                        id,
                        ...data
                    }
                    setPosts((posts) => [...posts, payload])
                })
            })
    }, [])

    return(
        <div className="posts_container container my-5 py-3">

            <div className="posts_header_container">
                <h1>All Orders</h1>
                <hr className="border-info"/>
            </div>

            <div className="articles_container">
                {
                    _.map(posts, (article, idx) => {
                        return(
                            <PostSnippet 
                            key = {idx}
                            doc= {article}
                           />
                        )                       
                    })
                }
                
            </div>


            <div className="product-device product-device-2 box-shadow d-none d-lg-block"></div>
            <div className="product-device product-device-3 box-shadow d-none d-lg-block"></div>
        </div>
    )
}

export default AllOrders;